export default "__VITE_ASSET__HUHz8U1s__"